export const findEnquiryOccasion = (occasions, selectedArea) => {
    const areaLinkId = selectedArea?.areaLinkGroup?.areaLinks?.[0]?.id;
    if (!areaLinkId || !Array.isArray(occasions)) return undefined;
    return occasions.find(o =>
        o.areaLinkGroup?.areaLinks?.[0]?.id === areaLinkId &&
        o.name?.includes('Enquiry'));
};

export const hasEnquiryOccasion = (occasions, selectedArea) =>
    !!findEnquiryOccasion(occasions, selectedArea);
